import * as React from 'react';
import { FC } from 'react';

const Error: FC<{ error: string }> = ({ error }) => {
  if (!error.length) return null;

  return (
    <div className="rs-column-small-12">
      <div id="errors" className="rs-panel rs-bg_alert rs-radius">
        {error}
      </div>
    </div>
  );
};

export default Error;
